<canvas
  #main
  [width]="width"
  [height]="height"
  class="mainCanvas"
  [ngClass]="{ 'is-full-size': fullSize }"
></canvas>

<canvas
  #anim
  [width]="width"
  [height]="height"
  class="animCanvas"
  [ngClass]="{ 'is-full-size': fullSize }"
></canvas>

<div
  class="eraser-cursor"
  #eraserCursor
  [style.--size]="(previewCursorSize$ | async) + 'px'"
  [style.--color]="previewCursorColor$ | async"
></div>
